module.exports = __webpack_public_path__ + "static/img/env-ribbon-tag-left.f9fbe067.svg";